import { Box, Typography } from "@mui/material";

const Photo = ({ src, alt, caption }) => {
  return (
    <Box width="350px" margin="25px" textAlign="center">
      <img
        src={src}
        alt={alt}
        width="350px"
        style={{
          boxShadow: `rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px`,
          borderRadius: "2%",
        }}
      />
      {caption ? (
        <Typography paddingTop="5px" fontFamily="Goblin One">
          {caption}
        </Typography>
      ) : null}
    </Box>
  );
};

export default Photo;
